import type { FieldSchemaModel, HiddenOnContext } from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const columnsQueries = {
	list: (page: HiddenOnContext) => ({
		queryKey: ['schema', page],
		queryFn: () =>
			client.fieldSchema.fieldSchemaList({
				context: [page],
			}),
	}),
}
export function useColumnsSchemaQuery<T = FieldSchemaModel[]>(
	page: HiddenOnContext,
	options?: UseQueryOptions<FieldSchemaModel[], Error, T>
) {
	return useQuery<FieldSchemaModel[], Error, T>({
		...columnsQueries.list(page),
		...(options || {}),
	})
}
